module.exports = __webpack_public_path__ + "img/1593141278.8594636f.jpg";